import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DtoInvoiceVM } from '../../../Model/orders/DtoInvoiceVM';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../Shared/Services/auth.service';
import { OrdersService } from '../../../Services/orders.service';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { DialogService } from '../../../Shared/Services/dialog.service';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrl: './order-list.component.scss'
})
export class OrderListComponent {
  @Input() AllInvoices: DtoInvoiceVM[] = [];
  totalOrderCost?: number = 0;
  @Output() newItemEvent = new EventEmitter<any>();

  constructor(private api: OrdersService, private auth: AuthService, private dialogService: DialogService, private router: Router,
    private spinner: NgxSpinnerService, private toastrService: CustomToastrService) { }

  DeleteOrder(invoiceId?: number) {
    if (this.auth.isAuthenticated([UserType.admin, UserType.Agent, UserType.Workshop])) {
      this.dialogService.confirmDialog({
        titleKey: 'confirmation',
        messageKey: 'AreYouSuretoDeleteThis',
        confirmTextKey: 'Yes',
        cancelTextKey: 'No'
      }).subscribe(isConfirmed => {
        if (isConfirmed) {
          this.spinner.show();
          this.ConfirmDeleteOrder(invoiceId);
        }
      });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  ConfirmDeleteOrder(invoiceId?: number) {
    if (this.auth.isAuthenticated([UserType.admin, UserType.Agent, UserType.Workshop])) {
      this.api.DeleteInvoices(invoiceId)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              if (data.isSuccess) {
                this.toastrService.showSuccessToast('Success', 'DeletedSuccessfully');

              } else {
                this.toastrService.showErrorToast('Error', data.message);
              }
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  ViewOrder(invoice?: DtoInvoiceVM) {
    this.newItemEvent.emit({ totalOrderCost: invoice?.totalWithInvoices, IsViewOrder: true });
  }
}
